__turbopack_context__.v({
  "fallback": "_6YWn0G_fallback",
  "options": "_6YWn0G_options",
  "orderStripe": "_6YWn0G_orderStripe",
  "productGroup": "_6YWn0G_productGroup",
  "productGroupLabel": "_6YWn0G_productGroupLabel",
  "standaloneItem": "_6YWn0G_standaloneItem",
});
